// ENCRÉ — custom.js
// Vidéos éditoriales : lecture uniquement lorsqu'elles sont visibles.
// Les visiteurs qui préfèrent réduire les animations ne subissent pas d'autoplay.
document.addEventListener('DOMContentLoaded', () => {
  const videos = Array.from(document.querySelectorAll('video[data-encre-autoplay]'));
  if (!videos.length) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const pauseAll = () => videos.forEach((video) => {
    video.pause();
    video.removeAttribute('autoplay');
  });

  if (reduceMotion.matches) {
    pauseAll();
    return;
  }

  if (!('IntersectionObserver' in window)) {
    videos.forEach((video) => video.play().catch(() => {}));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const video = entry.target;
      if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }, { threshold: [0, 0.25, 0.6] });

  videos.forEach((video) => observer.observe(video));

  reduceMotion.addEventListener?.('change', (event) => {
    if (event.matches) pauseAll();
    else videos.forEach((video) => observer.observe(video));
  });
});
